import { CEDE_CEXS } from "../../cexs";

export type Campaign = {
  tokenSymbol: string;
  campaignName: string;
  intervals?: {
    start: Date;
    end: Date;
    rule?: string;
    prize?: number;
    isPaused?: boolean;
    exchangeIds?: string[];
  }[];
  active?: boolean;
};

// todo move to a separate folder
export type NodeEnv = "development" | "staging" | "production" | "test" | "local";

export const enum Rule {
  FIXED_PER_VOLUME = "fixed-per-volume",
}

export enum OldTrackingTradingCampaignNames {
  IRONFISH = "ironfish",
  DOGAMI = "dogami",
  LYNEX = "lynex",
  OVAL3 = "oval3",
}

// TODO: Remove this function as soon as we definitively remove Mixpanel data from the trade reporting leaderboard
export const getCampaigns = (nodeEnv: NodeEnv | undefined): Record<string, Campaign> => {
  return {
    // !!! campaignName must be the same as a key
    dogami: {
      tokenSymbol: "DOGA",
      campaignName: "dogami",
    },
    lynex: {
      tokenSymbol: "LYNX",
      campaignName: "lynex",
    },
    oval3: {
      tokenSymbol: "OVL3",
      campaignName: "oval3",
      intervals: [
        // first interval is for testing purposes, it won't be displayed to users
        {
          start: new Date("2024-08-13T10:00:00Z"),
          end: new Date("2024-08-14T10:00:00Z"),
        },
        {
          start: new Date("2024-08-14T10:00:00Z"),
          end: new Date("2024-08-15T10:00:00Z"),
        },
        {
          start: new Date("2024-08-15T10:00:00Z"),
          end: new Date("2024-08-16T10:00:00Z"),
        },
        {
          start: new Date("2024-08-16T10:00:00Z"),
          end: new Date("2024-08-17T10:00:00Z"),
        },
        {
          start: new Date("2024-08-17T10:00:00Z"),
          end: new Date("2024-08-18T10:00:00Z"),
        },
        {
          start: new Date("2024-08-18T10:00:00Z"),
          end: new Date("2024-08-19T10:00:00Z"),
        },
        {
          start: new Date("2024-08-19T10:00:00Z"),
          end: new Date("2024-08-20T10:00:00Z"),
        },
      ],
    },
    thetanuts: {
      tokenSymbol: "NUTS",
      campaignName: "thetanuts",
      active: false,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-28T16:00:00Z"),
                end: new Date("2024-10-29T16:00:00Z"),
              },
              {
                start: new Date("2024-10-29T16:00:00Z"),
                end: new Date("2024-10-30T16:00:00Z"),
              },
              {
                start: new Date("2024-10-30T16:00:00Z"),
                end: new Date("2024-10-31T16:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-31T16:00:00Z"),
          end: new Date("2024-11-01T16:00:00Z"),
        },
        {
          start: new Date("2024-11-01T16:00:00Z"),
          end: new Date("2024-11-02T16:00:00Z"),
        },
        {
          start: new Date("2024-11-02T16:00:00Z"),
          end: new Date("2024-11-03T16:00:00Z"),
        },
        {
          start: new Date("2024-11-03T16:00:00Z"),
          end: new Date("2024-11-04T16:00:00Z"),
        },
        {
          start: new Date("2024-11-04T16:00:00Z"),
          end: new Date("2024-11-05T16:00:00Z"),
        },
        {
          start: new Date("2024-11-05T16:00:00Z"),
          end: new Date("2024-11-06T16:00:00Z"),
        },
        {
          start: new Date("2024-11-06T16:00:00Z"),
          end: new Date("2024-11-07T16:00:00Z"),
        },
        {
          start: new Date("2024-11-07T16:00:00Z"),
          end: new Date("2024-11-08T16:00:00Z"),
        },
        {
          start: new Date("2024-11-08T16:00:00Z"),
          end: new Date("2024-11-09T16:00:00Z"),
        },
        {
          start: new Date("2024-11-09T16:00:00Z"),
          end: new Date("2024-11-10T16:00:00Z"),
        },
        {
          start: new Date("2024-11-10T16:00:00Z"),
          end: new Date("2024-11-11T16:00:00Z"),
        },
        {
          start: new Date("2024-11-11T16:00:00Z"),
          end: new Date("2024-11-12T16:00:00Z"),
        },
        {
          start: new Date("2024-11-12T16:00:00Z"),
          end: new Date("2024-11-13T16:00:00Z"),
        },
        {
          start: new Date("2024-11-13T16:00:00Z"),
          end: new Date("2024-11-14T16:00:00Z"),
        },
        {
          start: new Date("2024-11-14T16:00:00Z"),
          end: new Date("2024-11-15T16:00:00Z"),
        },
        {
          start: new Date("2024-11-15T16:00:00Z"),
          end: new Date("2024-11-16T16:00:00Z"),
        },
        {
          start: new Date("2024-11-16T16:00:00Z"),
          end: new Date("2024-11-17T16:00:00Z"),
        },
        {
          start: new Date("2024-11-17T16:00:00Z"),
          end: new Date("2024-11-18T16:00:00Z"),
        },
        {
          start: new Date("2024-11-18T16:00:00Z"),
          end: new Date("2024-11-19T16:00:00Z"),
        },
        {
          start: new Date("2024-11-19T16:00:00Z"),
          end: new Date("2024-11-20T16:00:00Z"),
        },
        {
          start: new Date("2024-11-20T16:00:00Z"),
          end: new Date("2024-11-21T16:00:00Z"),
        },
        {
          start: new Date("2024-11-21T16:00:00Z"),
          end: new Date("2024-11-22T16:00:00Z"),
        },
        {
          start: new Date("2024-11-22T16:00:00Z"),
          end: new Date("2024-11-23T16:00:00Z"),
        },
        {
          start: new Date("2024-11-23T16:00:00Z"),
          end: new Date("2024-11-24T16:00:00Z"),
        },
        {
          start: new Date("2024-11-24T16:00:00Z"),
          end: new Date("2024-11-25T16:00:00Z"),
        },
        {
          start: new Date("2024-11-25T16:00:00Z"),
          end: new Date("2024-11-26T16:00:00Z"),
        },
        {
          start: new Date("2024-11-26T16:00:00Z"),
          end: new Date("2024-11-27T16:00:00Z"),
        },
        {
          start: new Date("2024-11-27T16:00:00Z"),
          end: new Date("2024-11-28T16:00:00Z"),
        },
      ],
    },
    thetanuts2: {
      tokenSymbol: "NUTS",
      campaignName: "thetanuts2",
      active: true,
      intervals: [
        {
          start: new Date("2024-11-28T16:00:00.000Z"),
          end: new Date("2024-11-29T16:00:00.000Z"),
        },
        {
          start: new Date("2024-11-29T16:00:00.000Z"),
          end: new Date("2024-11-30T16:00:00.000Z"),
        },
        {
          start: new Date("2024-11-30T16:00:00.000Z"),
          end: new Date("2024-12-01T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-01T16:00:00.000Z"),
          end: new Date("2024-12-02T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-02T16:00:00.000Z"),
          end: new Date("2024-12-03T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-03T16:00:00.000Z"),
          end: new Date("2024-12-04T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-04T16:00:00.000Z"),
          end: new Date("2024-12-05T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-05T16:00:00.000Z"),
          end: new Date("2024-12-06T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-06T16:00:00.000Z"),
          end: new Date("2024-12-07T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-07T16:00:00.000Z"),
          end: new Date("2024-12-08T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-08T16:00:00.000Z"),
          end: new Date("2024-12-09T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-09T16:00:00.000Z"),
          end: new Date("2024-12-10T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-10T16:00:00.000Z"),
          end: new Date("2024-12-11T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-11T16:00:00.000Z"),
          end: new Date("2024-12-12T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-12T16:00:00.000Z"),
          end: new Date("2024-12-13T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-13T16:00:00.000Z"),
          end: new Date("2024-12-14T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-14T16:00:00.000Z"),
          end: new Date("2024-12-15T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-15T16:00:00.000Z"),
          end: new Date("2024-12-16T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-16T16:00:00.000Z"),
          end: new Date("2024-12-17T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-17T16:00:00.000Z"),
          end: new Date("2024-12-18T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-18T16:00:00.000Z"),
          end: new Date("2024-12-19T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-19T16:00:00.000Z"),
          end: new Date("2024-12-20T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-20T16:00:00.000Z"),
          end: new Date("2024-12-21T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-21T16:00:00.000Z"),
          end: new Date("2024-12-22T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-22T16:00:00.000Z"),
          end: new Date("2024-12-23T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-23T16:00:00.000Z"),
          end: new Date("2024-12-24T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-24T16:00:00.000Z"),
          end: new Date("2024-12-25T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-25T16:00:00.000Z"),
          end: new Date("2024-12-26T16:00:00.000Z"),
        },
      ],
    },
    lime: {
      tokenSymbol: "LIME",
      campaignName: "lime",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-28T15:00:00Z"),
                end: new Date("2024-10-29T15:00:00Z"),
              },
              {
                start: new Date("2024-10-29T15:00:00Z"),
                end: new Date("2024-10-30T15:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-30T15:00:00Z"),
          end: new Date("2024-10-31T15:00:00Z"),
        },
        {
          start: new Date("2024-10-31T15:00:00Z"),
          end: new Date("2024-11-01T15:00:00Z"),
        },
        {
          start: new Date("2024-11-01T15:00:00Z"),
          end: new Date("2024-11-02T15:00:00Z"),
        },
        {
          start: new Date("2024-11-02T15:00:00Z"),
          end: new Date("2024-11-03T15:00:00Z"),
        },
        {
          start: new Date("2024-11-03T15:00:00Z"),
          end: new Date("2024-11-04T15:00:00Z"),
        },
        {
          start: new Date("2024-11-04T15:00:00Z"),
          end: new Date("2024-11-05T15:00:00Z"),
        },
        {
          start: new Date("2024-11-05T15:00:00Z"),
          end: new Date("2024-11-06T15:00:00Z"),
        },
      ],
    },
    ethermail: {
      tokenSymbol: "EMT",
      campaignName: "ethermail",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-28T13:00:00Z"),
                end: new Date("2024-10-29T13:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-29T13:00:00Z"),
          end: new Date("2024-10-30T13:00:00Z"),
        },
        {
          start: new Date("2024-10-30T13:00:00Z"),
          end: new Date("2024-10-31T13:00:00Z"),
        },
        {
          start: new Date("2024-10-31T13:00:00Z"),
          end: new Date("2024-11-01T13:00:00Z"),
        },
        {
          start: new Date("2024-11-01T13:00:00Z"),
          end: new Date("2024-11-02T13:00:00Z"),
        },
        {
          start: new Date("2024-11-02T13:00:00Z"),
          end: new Date("2024-11-03T13:00:00Z"),
        },
        {
          start: new Date("2024-11-03T13:00:00Z"),
          end: new Date("2024-11-04T13:00:00Z"),
        },
        {
          start: new Date("2024-11-04T13:00:00Z"),
          end: new Date("2024-11-05T13:00:00Z"),
        },
      ],
    },
    realis: {
      tokenSymbol: "LIS",
      campaignName: "realis",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-25T11:00:00Z"),
                end: new Date("2024-10-26T11:00:00Z"),
              },
              {
                start: new Date("2024-10-26T11:00:00Z"),
                end: new Date("2024-10-27T11:00:00Z"),
              },
              {
                start: new Date("2024-10-27T11:00:00Z"),
                end: new Date("2024-10-28T11:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-28T11:00:00Z"),
          end: new Date("2024-10-29T11:00:00Z"),
        },
        {
          start: new Date("2024-10-29T11:00:00Z"),
          end: new Date("2024-10-30T11:00:00Z"),
        },
        {
          start: new Date("2024-10-30T11:00:00Z"),
          end: new Date("2024-10-31T11:00:00Z"),
        },
        {
          start: new Date("2024-10-31T11:00:00Z"),
          end: new Date("2024-11-01T11:00:00Z"),
        },
        {
          start: new Date("2024-11-01T11:00:00Z"),
          end: new Date("2024-11-02T11:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-02T11:00:00Z"),
          end: new Date("2024-11-03T11:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-03T11:00:00Z"),
          end: new Date("2024-11-04T11:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-04T11:00:00Z"),
          end: new Date("2024-11-05T11:00:00Z"),
          rule: "special-realis-last-day",
        },
      ],
    },
    plutus: {
      tokenSymbol: "PLU",
      campaignName: "plutus",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-23T10:00:00Z"),
                end: new Date("2024-10-24T10:00:00Z"),
              },
              {
                start: new Date("2024-10-24T10:00:00Z"),
                end: new Date("2024-10-25T10:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-25T10:00:00Z"),
          end: new Date("2024-10-26T10:00:00Z"),
        },
        {
          start: new Date("2024-10-26T10:00:00Z"),
          end: new Date("2024-10-27T10:00:00Z"),
        },
        {
          start: new Date("2024-10-27T10:00:00Z"),
          end: new Date("2024-10-28T10:00:00Z"),
        },
        {
          start: new Date("2024-10-28T10:00:00Z"),
          end: new Date("2024-10-29T10:00:00Z"),
        },
        {
          start: new Date("2024-10-29T10:00:00Z"),
          end: new Date("2024-10-30T10:00:00Z"),
        },
        {
          start: new Date("2024-10-30T10:00:00Z"),
          end: new Date("2024-10-31T10:00:00Z"),
        },
        {
          start: new Date("2024-10-31T10:00:00Z"),
          end: new Date("2024-11-01T10:00:00Z"),
        },
      ],
    },
    aipad: {
      tokenSymbol: "AIPAD",
      campaignName: "aipad",
      active: false,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-23T14:00:00Z"),
                end: new Date("2024-10-24T14:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-24T14:00:00Z"),
          end: new Date("2024-10-25T14:00:00Z"),
        },
        {
          start: new Date("2024-10-25T14:00:00Z"),
          end: new Date("2024-10-26T14:00:00Z"),
        },
        {
          start: new Date("2024-10-26T14:00:00Z"),
          end: new Date("2024-10-27T14:00:00Z"),
        },
        {
          start: new Date("2024-10-27T14:00:00Z"),
          end: new Date("2024-10-28T14:00:00Z"),
        },
        {
          start: new Date("2024-10-28T14:00:00Z"),
          end: new Date("2024-10-29T14:00:00Z"),
        },
        {
          start: new Date("2024-10-29T14:00:00Z"),
          end: new Date("2024-10-30T14:00:00Z"),
        },
        {
          start: new Date("2024-10-30T14:00:00Z"),
          end: new Date("2024-10-31T14:00:00Z"),
        },
        {
          start: new Date("2024-10-31T14:00:00Z"),
          end: new Date("2024-11-01T14:00:00Z"),
        },
        {
          start: new Date("2024-11-01T14:00:00Z"),
          end: new Date("2024-11-02T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-02T14:00:00Z"),
          end: new Date("2024-11-03T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-03T14:00:00Z"),
          end: new Date("2024-11-04T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-04T14:00:00Z"),
          end: new Date("2024-11-05T14:00:00Z"),
          rule: "prize-by-slot-easy",
        },
        {
          start: new Date("2024-11-05T14:00:00Z"),
          end: new Date("2024-11-06T14:00:00Z"),
          rule: "prize-by-slot-easy",
        },
        {
          start: new Date("2024-11-06T14:00:00Z"),
          end: new Date("2024-11-07T14:00:00Z"),
          rule: "prize-by-slot-easy",
        },
        {
          start: new Date("2024-11-07T14:00:00Z"),
          end: new Date("2024-11-08T14:00:00Z"),
          rule: "prize-by-slot-easy",
        },
        {
          start: new Date("2024-11-08T14:00:00Z"),
          end: new Date("2024-11-09T14:00:00Z"),
          rule: "prize-by-slot-easy",
        },
        {
          start: new Date("2024-11-09T14:00:00Z"),
          end: new Date("2024-11-10T14:00:00Z"),
          rule: "prize-by-slot-easy-290",
        },
      ],
    },
    aipad2: {
      tokenSymbol: "AIPAD",
      campaignName: "aipad2",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-11-28T16:00:00Z"),
                end: new Date("2024-11-29T16:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-11-29T16:00:00.000Z"),
          end: new Date("2024-11-30T16:00:00.000Z"),
        },
        {
          start: new Date("2024-11-30T16:00:00.000Z"),
          end: new Date("2024-12-01T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-01T16:00:00.000Z"),
          end: new Date("2024-12-02T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-02T16:00:00.000Z"),
          end: new Date("2024-12-03T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-03T16:00:00.000Z"),
          end: new Date("2024-12-04T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-04T16:00:00.000Z"),
          end: new Date("2024-12-05T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-05T16:00:00.000Z"),
          end: new Date("2024-12-06T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-06T16:00:00.000Z"),
          end: new Date("2024-12-07T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-07T16:00:00.000Z"),
          end: new Date("2024-12-08T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-08T16:00:00.000Z"),
          end: new Date("2024-12-09T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-09T16:00:00.000Z"),
          end: new Date("2024-12-10T16:00:00.000Z"),
          isPaused: true,
        },
        {
          start: new Date("2024-12-10T16:00:00.000Z"),
          end: new Date("2024-12-11T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-11T16:00:00.000Z"),
          end: new Date("2024-12-12T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-12T16:00:00.000Z"),
          end: new Date("2024-12-13T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-13T16:00:00.000Z"),
          end: new Date("2024-12-14T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-14T16:00:00.000Z"),
          end: new Date("2024-12-15T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-15T16:00:00.000Z"),
          end: new Date("2024-12-16T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-16T16:00:00.000Z"),
          end: new Date("2024-12-17T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-17T16:00:00.000Z"),
          end: new Date("2024-12-18T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-18T16:00:00.000Z"),
          end: new Date("2024-12-19T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-19T16:00:00.000Z"),
          end: new Date("2024-12-20T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-20T16:00:00.000Z"),
          end: new Date("2024-12-21T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-21T16:00:00.000Z"),
          end: new Date("2024-12-22T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-22T16:00:00.000Z"),
          end: new Date("2024-12-23T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-23T16:00:00.000Z"),
          end: new Date("2024-12-24T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-24T16:00:00.000Z"),
          end: new Date("2024-12-25T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-25T16:00:00.000Z"),
          end: new Date("2024-12-26T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-26T16:00:00.000Z"),
          end: new Date("2024-12-27T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-27T16:00:00.000Z"),
          end: new Date("2024-12-28T16:00:00.000Z"),
        },
        {
          start: new Date("2024-12-28T16:00:00.000Z"),
          end: new Date("2024-12-29T16:00:00.000Z"),
        },
      ],
    },
    dogami2: {
      tokenSymbol: "DOGA",
      campaignName: "dogami2",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-12-02T13:00:00.000Z"),
                end: new Date("2024-12-03T13:00:00.000Z"),
                isPaused: true,
              },
              {
                start: new Date("2024-12-03T13:00:00.000Z"),
                end: new Date("2024-12-04T13:00:00.000Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-12-04T13:00:00.000Z"),
          end: new Date("2024-12-05T13:00:00.000Z"),
        },
        {
          start: new Date("2024-12-05T13:00:00.000Z"),
          end: new Date("2024-12-06T13:00:00.000Z"),
        },
        {
          start: new Date("2024-12-06T13:00:00.000Z"),
          end: new Date("2024-12-07T13:00:00.000Z"),
        },
        {
          start: new Date("2024-12-07T13:00:00.000Z"),
          end: new Date("2024-12-08T13:00:00.000Z"),
        },
        {
          start: new Date("2024-12-08T13:00:00.000Z"),
          end: new Date("2024-12-09T13:00:00.000Z"),
        },
        {
          start: new Date("2024-12-09T13:00:00.000Z"),
          end: new Date("2024-12-10T13:00:00.000Z"),
        },
        {
          start: new Date("2024-12-10T13:00:00.000Z"),
          end: new Date("2024-12-11T13:00:00.000Z"),
        },
      ],
    },
    gpt: {
      tokenSymbol: "GPT",
      campaignName: "gpt",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-22T12:00:00Z"),
                end: new Date("2024-10-23T12:30:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-23T12:30:00Z"),
          end: new Date("2024-10-24T12:00:00Z"),
        },
        {
          start: new Date("2024-10-24T12:00:00Z"),
          end: new Date("2024-10-25T12:00:00Z"),
        },
        {
          start: new Date("2024-10-25T12:00:00Z"),
          end: new Date("2024-10-26T12:00:00Z"),
        },
        {
          start: new Date("2024-10-26T12:00:00Z"),
          end: new Date("2024-10-27T12:00:00Z"),
        },
        {
          start: new Date("2024-10-27T12:00:00Z"),
          end: new Date("2024-10-28T12:00:00Z"),
        },
        {
          start: new Date("2024-10-28T12:00:00Z"),
          end: new Date("2024-10-29T12:00:00Z"),
        },
        {
          start: new Date("2024-10-29T12:00:00Z"),
          end: new Date("2024-10-30T12:00:00Z"),
        },
      ],
    },
    ironfish: {
      tokenSymbol: "IRON",
      campaignName: "ironfish",
      intervals: [
        {
          start: new Date("2024-09-02T10:00:00Z"),
          end: new Date("2024-09-03T10:00:00Z"),
        },
        {
          start: new Date("2024-09-03T10:00:00Z"),
          end: new Date("2024-09-04T10:00:00Z"),
        },
        {
          start: new Date("2024-09-04T10:00:00Z"),
          end: new Date("2024-09-05T10:00:00Z"),
        },
        {
          start: new Date("2024-09-05T10:00:00Z"),
          end: new Date("2024-09-06T10:00:00Z"),
        },
        {
          start: new Date("2024-09-06T10:00:00Z"),
          end: new Date("2024-09-07T10:00:00Z"),
        },
        {
          start: new Date("2024-09-07T10:00:00Z"),
          end: new Date("2024-09-08T10:00:00Z"),
        },
        {
          start: new Date("2024-09-08T10:00:00Z"),
          end: new Date("2024-09-09T10:00:00Z"),
        },
        {
          start: new Date("2024-09-09T10:00:00Z"),
          end: new Date("2024-09-10T10:00:00Z"),
        },
        {
          start: new Date("2024-09-10T10:00:00Z"),
          end: new Date("2024-09-11T10:00:00Z"),
        },
        {
          start: new Date("2024-09-11T10:00:00Z"),
          end: new Date("2024-09-12T10:00:00Z"),
        },
        {
          start: new Date("2024-09-12T10:00:00Z"),
          end: new Date("2024-09-13T10:00:00Z"),
        },
        {
          start: new Date("2024-09-13T10:00:00Z"),
          end: new Date("2024-09-14T10:00:00Z"),
        },
        {
          start: new Date("2024-09-14T10:00:00Z"),
          end: new Date("2024-09-15T10:00:00Z"),
        },
        {
          start: new Date("2024-09-15T10:00:00Z"),
          end: new Date("2024-09-16T10:00:00Z"),
        },
        {
          start: new Date("2024-09-16T10:00:00Z"),
          end: new Date("2024-09-17T18:00:00Z"),
          rule: "king-of-the-hill",
        },
        {
          start: new Date("2024-09-17T18:00:00Z"),
          end: new Date("2024-09-18T18:00:00Z"),
          rule: "king-of-the-hill",
        },
        {
          start: new Date("2024-09-18T18:00:00Z"),
          end: new Date("2024-09-19T18:00:00Z"),
          rule: "king-of-the-hill",
        },
        {
          start: new Date("2024-09-19T18:00:00Z"),
          end: new Date("2024-09-20T18:00:00Z"),
          rule: "king-of-the-hill",
        },
        {
          start: new Date("2024-09-20T18:00:00Z"),
          end: new Date("2024-09-21T18:00:00Z"),
          rule: "king-of-the-hill",
        },
        {
          start: new Date("2024-09-21T18:00:00Z"),
          end: new Date("2024-09-22T18:00:00Z"),
          rule: "king-of-the-hill",
        },
        {
          start: new Date("2024-09-22T18:00:00Z"),
          end: new Date("2024-09-23T18:00:00Z"),
          rule: "king-of-the-hill",
        },
        {
          start: new Date("2024-09-23T18:00:00Z"),
          end: new Date("2024-09-24T18:00:00Z"),
          isPaused: true,
          rule: "3-traders-40-k",
        },
        {
          start: new Date("2024-09-24T18:00:00Z"),
          end: new Date("2024-09-25T18:00:00Z"),
          rule: "3-traders-40-k",
        },
        {
          start: new Date("2024-09-25T18:00:00Z"),
          end: new Date("2024-10-08T18:00:00Z"),
          rule: "3-traders-40-k",
          isPaused: true,
        },
      ],
    },
    test2: {
      tokenSymbol: "ETH",
      campaignName: "test2",
      active: true,
      intervals: [
        {
          start: new Date("2024-10-21T14:00:00Z"),
          end: new Date("2024-10-22T14:00:00Z"),
        },
        {
          start: new Date("2024-10-22T14:00:00Z"),
          end: new Date("2024-10-23T14:00:00Z"),
        },
        {
          start: new Date("2024-10-23T14:00:00Z"),
          end: new Date("2024-10-24T14:00:00Z"),
        },
      ],
    },
    trakx: {
      tokenSymbol: "TRKX",
      campaignName: "trakx",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-13T14:00:00Z"),
                end: new Date("2024-10-14T14:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-14T14:00:00Z"),
          end: new Date("2024-10-15T14:00:00Z"),
        },
        {
          start: new Date("2024-10-15T14:00:00Z"),
          end: new Date("2024-10-16T14:00:00Z"),
        },
        {
          start: new Date("2024-10-16T14:00:00Z"),
          end: new Date("2024-10-17T14:00:00Z"),
        },
        {
          start: new Date("2024-10-17T14:00:00Z"),
          end: new Date("2024-10-18T14:00:00Z"),
        },
        {
          start: new Date("2024-10-18T14:00:00Z"),
          end: new Date("2024-10-19T14:00:00Z"),
        },
        {
          start: new Date("2024-10-19T14:00:00Z"),
          end: new Date("2024-10-20T14:00:00Z"),
        },
        {
          start: new Date("2024-10-20T14:00:00Z"),
          end: new Date("2024-10-21T14:00:00Z"),
        },
        {
          start: new Date("2024-10-21T14:00:00Z"),
          end: new Date("2024-10-22T14:00:00Z"),
        },
        {
          start: new Date("2024-10-22T14:00:00Z"),
          end: new Date("2024-10-23T14:00:00Z"),
        },
        {
          start: new Date("2024-10-23T14:00:00Z"),
          end: new Date("2024-10-24T14:00:00Z"),
        },
        {
          start: new Date("2024-10-24T14:00:00Z"),
          end: new Date("2024-10-25T14:00:00Z"),
        },
        {
          start: new Date("2024-10-25T14:00:00Z"),
          end: new Date("2024-10-26T14:00:00Z"),
        },
        {
          start: new Date("2024-10-26T14:00:00Z"),
          end: new Date("2024-10-27T14:00:00Z"),
        },
        {
          start: new Date("2024-10-27T14:00:00Z"),
          end: new Date("2024-10-28T14:00:00Z"),
        },
        {
          start: new Date("2024-10-28T14:00:00Z"),
          end: new Date("2024-10-29T14:00:00Z"),
        },
        {
          start: new Date("2024-10-29T14:00:00Z"),
          end: new Date("2024-10-30T14:00:00Z"),
        },
        {
          start: new Date("2024-10-30T14:00:00Z"),
          end: new Date("2024-10-31T14:00:00Z"),
        },
        {
          start: new Date("2024-10-31T14:00:00Z"),
          end: new Date("2024-11-01T14:00:00Z"),
        },
        {
          start: new Date("2024-11-01T14:00:00Z"),
          end: new Date("2024-11-02T14:00:00Z"),
        },
        {
          start: new Date("2024-11-02T14:00:00Z"),
          end: new Date("2024-11-03T14:00:00Z"),
        },
        {
          start: new Date("2024-11-03T14:00:00Z"),
          end: new Date("2024-11-04T14:00:00Z"),
        },
        {
          start: new Date("2024-11-04T14:00:00Z"),
          end: new Date("2024-11-05T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-05T14:00:00Z"),
          end: new Date("2024-11-06T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-06T14:00:00Z"),
          end: new Date("2024-11-07T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-07T14:00:00Z"),
          end: new Date("2024-11-08T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-08T14:00:00Z"),
          end: new Date("2024-11-09T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-09T14:00:00Z"),
          end: new Date("2024-11-10T14:00:00Z"),
          rule: "prize-by-slot",
        },
        {
          start: new Date("2024-11-10T14:00:00Z"),
          end: new Date("2024-11-11T14:00:00Z"),
          rule: "prize-by-slot",
        },
      ],
    },
    ironfish2: {
      tokenSymbol: "IRON",
      campaignName: "ironfish2",
      active: false,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-01T18:00:00Z"),
                end: new Date("2024-10-02T18:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-03T18:00:00Z"),
          end: new Date("2024-10-04T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-04T18:00:00Z"),
          end: new Date("2024-10-05T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-05T18:00:00Z"),
          end: new Date("2024-10-06T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-06T18:00:00Z"),
          end: new Date("2024-10-07T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-07T18:00:00Z"),
          end: new Date("2024-10-08T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-08T18:00:00Z"),
          end: new Date("2024-10-09T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-09T18:00:00Z"),
          end: new Date("2024-10-10T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        // 8 epoch, rules change + kucoin deactivated
        {
          start: new Date("2024-10-10T18:00:00Z"),
          end: new Date("2024-10-11T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-11T18:00:00Z"),
          end: new Date("2024-10-12T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-12T18:00:00Z"),
          end: new Date("2024-10-13T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-13T18:00:00Z"),
          end: new Date("2024-10-14T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-14T18:00:00Z"),
          end: new Date("2024-10-15T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-15T18:00:00Z"),
          end: new Date("2024-10-16T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-16T18:00:00Z"),
          end: new Date("2024-10-17T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-17T18:00:00Z"),
          end: new Date("2024-10-18T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-18T18:00:00Z"),
          end: new Date("2024-10-19T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-19T18:00:00Z"),
          end: new Date("2024-10-20T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-20T18:00:00Z"),
          end: new Date("2024-10-21T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-21T18:00:00Z"),
          end: new Date("2024-10-22T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-22T18:00:00Z"),
          end: new Date("2024-10-23T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-23T18:00:00Z"),
          end: new Date("2024-10-24T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-24T18:00:00Z"),
          end: new Date("2024-10-25T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-25T18:00:00Z"),
          end: new Date("2024-10-26T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-26T18:00:00Z"),
          end: new Date("2024-10-27T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-27T18:00:00Z"),
          end: new Date("2024-10-28T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-28T18:00:00Z"),
          end: new Date("2024-10-29T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-29T18:00:00Z"),
          end: new Date("2024-10-30T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
        {
          start: new Date("2024-10-30T18:00:00Z"),
          end: new Date("2024-10-31T18:00:00Z"),
          rule: "proportional",
          exchangeIds: [CEDE_CEXS.MEXC, CEDE_CEXS.GATEIO],
          prize: 355,
        },
      ],
    },

    test: {
      tokenSymbol: "ETH",
      campaignName: "test",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-01T18:00:00Z"),
                end: new Date("2024-10-02T18:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-10-03T18:00:00Z"),
          end: new Date("2024-10-04T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-04T18:00:00Z"),
          end: new Date("2024-10-05T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-05T18:00:00Z"),
          end: new Date("2024-10-06T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-06T18:00:00Z"),
          end: new Date("2024-10-07T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-07T18:00:00Z"),
          end: new Date("2024-10-08T18:00:00Z"),
          rule: "3-traders-30-k",
        },
        {
          start: new Date("2024-10-08T18:00:00Z"),
          end: new Date("2024-10-09T18:00:00Z"),
          rule: "3-traders-30-k",
        },
      ],
    },
    metatrace: {
      tokenSymbol: "TRC",
      campaignName: "metatrace",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-10-18T14:00:00Z"),
                end: new Date("2024-10-19T14:00:00Z"),
                rule: "3-traders-25-k",
              },
              {
                start: new Date("2024-10-19T14:00:00Z"),
                end: new Date("2024-10-20T14:00:00Z"),
                rule: "3-traders-25-k",
              },
              {
                start: new Date("2024-10-20T14:00:00Z"),
                end: new Date("2024-10-21T14:00:00Z"),
                rule: "3-traders-25-k",
              },
            ]
          : []),
        {
          start: new Date("2024-10-21T14:00:00Z"),
          end: new Date("2024-10-22T14:00:00Z"),
          rule: "3-traders-25-k",
        },
        {
          start: new Date("2024-10-22T14:00:00Z"),
          end: new Date("2024-10-23T14:00:00Z"),
          rule: "3-traders-25-k",
        },
        {
          start: new Date("2024-10-23T14:00:00Z"),
          end: new Date("2024-10-24T14:00:00Z"),
          rule: "3-traders-25-k",
        },
        {
          start: new Date("2024-10-24T14:00:00Z"),
          end: new Date("2024-10-25T14:00:00Z"),
          rule: "3-traders-25-k",
        },
        {
          start: new Date("2024-10-25T14:00:00Z"),
          end: new Date("2024-10-26T14:00:00Z"),
          rule: "3-traders-25-k",
        },
        {
          start: new Date("2024-10-26T14:00:00Z"),
          end: new Date("2024-10-27T14:00:00Z"),
          rule: "3-traders-25-k",
        },
        {
          start: new Date("2024-10-27T14:00:00Z"),
          end: new Date("2024-10-28T14:00:00Z"),
          rule: "3-traders-25-k",
        },
      ],
    },
    ironfish3: {
      tokenSymbol: "IRON",
      campaignName: "ironfish3",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-11-12T14:00:00Z"),
                end: new Date("2024-11-13T14:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-11-13T14:00:00Z"),
          end: new Date("2024-11-14T14:00:00Z"),
        },
        {
          start: new Date("2024-11-14T14:00:00Z"),
          end: new Date("2024-11-15T14:00:00Z"),
        },
        {
          start: new Date("2024-11-15T14:00:00Z"),
          end: new Date("2024-11-16T14:00:00Z"),
        },
        {
          start: new Date("2024-11-16T14:00:00Z"),
          end: new Date("2024-11-17T14:00:00Z"),
        },
        {
          start: new Date("2024-11-17T14:00:00Z"),
          end: new Date("2024-11-18T14:00:00Z"),
        },
        {
          start: new Date("2024-11-18T14:00:00Z"),
          end: new Date("2024-11-19T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-19T14:00:00Z"),
          end: new Date("2024-11-20T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-20T14:00:00Z"),
          end: new Date("2024-11-21T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-21T14:00:00Z"),
          end: new Date("2024-11-22T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-22T14:00:00Z"),
          end: new Date("2024-11-23T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-23T14:00:00Z"),
          end: new Date("2024-11-24T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-24T14:00:00Z"),
          end: new Date("2024-11-25T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-25T14:00:00Z"),
          end: new Date("2024-11-26T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-26T14:00:00Z"),
          end: new Date("2024-11-27T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-27T14:00:00Z"),
          end: new Date("2024-11-28T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-28T14:00:00Z"),
          end: new Date("2024-11-29T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-29T14:00:00Z"),
          end: new Date("2024-11-30T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-30T14:00:00Z"),
          end: new Date("2024-12-01T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-01T14:00:00Z"),
          end: new Date("2024-12-02T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-02T14:00:00Z"),
          end: new Date("2024-12-03T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-03T14:00:00Z"),
          end: new Date("2024-12-04T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-04T14:00:00Z"),
          end: new Date("2024-12-05T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-05T14:00:00Z"),
          end: new Date("2024-12-06T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-06T14:00:00Z"),
          end: new Date("2024-12-07T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-07T14:00:00Z"),
          end: new Date("2024-12-08T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-08T14:00:00Z"),
          end: new Date("2024-12-09T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-09T14:00:00Z"),
          end: new Date("2024-12-10T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-12-10T14:00:00Z"),
          end: new Date("2024-12-11T14:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
      ],
    },
    logx: {
      tokenSymbol: "LOGX",
      campaignName: "logx",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-11-17T17:00:00Z"),
                end: new Date("2024-11-18T17:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-11-18T17:00:00Z"),
          end: new Date("2024-11-19T17:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-19T17:00:00Z"),
          end: new Date("2024-11-20T17:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-20T17:00:00Z"),
          end: new Date("2024-11-21T17:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-21T17:00:00Z"),
          end: new Date("2024-11-22T17:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-22T17:00:00Z"),
          end: new Date("2024-11-23T17:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-23T17:00:00Z"),
          end: new Date("2024-11-24T17:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
        {
          start: new Date("2024-11-24T17:00:00Z"),
          end: new Date("2024-11-25T17:00:00Z"),
          rule: Rule.FIXED_PER_VOLUME,
        },
      ],
    },
    artrade: {
      tokenSymbol: "ATR",
      campaignName: "artrade",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-11-17T11:00:00Z"),
                end: new Date("2024-11-18T11:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-11-18T11:00:00Z"),
          end: new Date("2024-11-19T11:00:00Z"),
        },
        {
          start: new Date("2024-11-19T11:00:00Z"),
          end: new Date("2024-11-20T11:00:00Z"),
        },
        {
          start: new Date("2024-11-20T11:00:00Z"),
          end: new Date("2024-11-21T11:00:00Z"),
        },
        {
          start: new Date("2024-11-21T11:00:00Z"),
          end: new Date("2024-11-22T11:00:00Z"),
        },
        {
          start: new Date("2024-11-22T11:00:00Z"),
          end: new Date("2024-11-23T11:00:00Z"),
        },
        {
          start: new Date("2024-11-23T11:00:00Z"),
          end: new Date("2024-11-24T11:00:00Z"),
        },
        {
          start: new Date("2024-11-24T11:00:00Z"),
          end: new Date("2024-11-25T11:00:00Z"),
        },
        {
          start: new Date("2024-11-25T11:00:00Z"),
          end: new Date("2024-11-26T11:00:00Z"),
        },
        {
          start: new Date("2024-11-26T11:00:00Z"),
          end: new Date("2024-11-27T11:00:00Z"),
        },
        {
          start: new Date("2024-11-27T11:00:00Z"),
          end: new Date("2024-11-28T11:00:00Z"),
        },
        {
          start: new Date("2024-11-28T11:00:00Z"),
          end: new Date("2024-11-29T11:00:00Z"),
        },
        {
          start: new Date("2024-11-29T11:00:00Z"),
          end: new Date("2024-11-30T11:00:00Z"),
        },
        {
          start: new Date("2024-11-30T11:00:00Z"),
          end: new Date("2024-12-01T11:00:00Z"),
        },
        {
          start: new Date("2024-12-01T11:00:00Z"),
          end: new Date("2024-12-02T11:00:00Z"),
        },
        {
          start: new Date("2024-12-02T11:00:00Z"),
          end: new Date("2024-12-03T11:00:00Z"),
        },
        {
          start: new Date("2024-12-03T11:00:00Z"),
          end: new Date("2024-12-04T11:00:00Z"),
        },
        {
          start: new Date("2024-12-04T11:00:00Z"),
          end: new Date("2024-12-05T11:00:00Z"),
        },
        {
          start: new Date("2024-12-05T11:00:00Z"),
          end: new Date("2024-12-06T11:00:00Z"),
        },
        {
          start: new Date("2024-12-06T11:00:00Z"),
          end: new Date("2024-12-07T11:00:00Z"),
        },
        {
          start: new Date("2024-12-07T11:00:00Z"),
          end: new Date("2024-12-08T11:00:00Z"),
        },
        {
          start: new Date("2024-12-08T11:00:00Z"),
          end: new Date("2024-12-09T11:00:00Z"),
        },
        {
          start: new Date("2024-12-09T11:00:00Z"),
          end: new Date("2024-12-10T11:00:00Z"),
        },
        {
          start: new Date("2024-12-10T11:00:00Z"),
          end: new Date("2024-12-11T11:00:00Z"),
        },
        {
          start: new Date("2024-12-11T11:00:00Z"),
          end: new Date("2024-12-12T11:00:00Z"),
        },
        {
          start: new Date("2024-12-12T11:00:00Z"),
          end: new Date("2024-12-13T11:00:00Z"),
        },
        {
          start: new Date("2024-12-13T11:00:00Z"),
          end: new Date("2024-12-14T11:00:00Z"),
        },
        {
          start: new Date("2024-12-14T11:00:00Z"),
          end: new Date("2024-12-15T11:00:00Z"),
        },
        {
          start: new Date("2024-12-15T11:00:00Z"),
          end: new Date("2024-12-16T11:00:00Z"),
        },
      ],
    },
    famemma: {
      tokenSymbol: "FAME",
      campaignName: "famemma",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-12-04T10:00:00Z"),
                end: new Date("2024-12-05T15:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-12-05T15:00:00.000Z"),
          end: new Date("2024-12-06T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-06T15:00:00.000Z"),
          end: new Date("2024-12-07T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-07T15:00:00.000Z"),
          end: new Date("2024-12-08T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-08T15:00:00.000Z"),
          end: new Date("2024-12-09T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-09T15:00:00.000Z"),
          end: new Date("2024-12-10T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-10T15:00:00.000Z"),
          end: new Date("2024-12-11T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-11T15:00:00.000Z"),
          end: new Date("2024-12-12T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-12T15:00:00.000Z"),
          end: new Date("2024-12-13T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-13T15:00:00.000Z"),
          end: new Date("2024-12-14T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-14T15:00:00.000Z"),
          end: new Date("2024-12-15T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-15T15:00:00.000Z"),
          end: new Date("2024-12-16T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-16T15:00:00.000Z"),
          end: new Date("2024-12-17T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-17T15:00:00.000Z"),
          end: new Date("2024-12-18T15:00:00.000Z"),
        },
        {
          start: new Date("2024-12-18T15:00:00.000Z"),
          end: new Date("2024-12-19T15:00:00.000Z"),
        },
      ],
    },
    metafight: {
      tokenSymbol: "MFT",
      campaignName: "metafight",
      active: true,
      intervals: [
        ...(nodeEnv === "development"
          ? [
              {
                start: new Date("2024-12-04T10:00:00Z"),
                end: new Date("2024-12-05T10:00:00Z"),
              },
              {
                start: new Date("2024-12-05T10:00:00Z"),
                end: new Date("2024-12-06T10:00:00Z"),
              },
            ]
          : []),
        {
          start: new Date("2024-12-06T10:00:00.000Z"),
          end: new Date("2024-12-07T10:00:00.000Z"),
        },
        {
          start: new Date("2024-12-07T10:00:00.000Z"),
          end: new Date("2024-12-08T10:00:00.000Z"),
        },
        {
          start: new Date("2024-12-08T10:00:00.000Z"),
          end: new Date("2024-12-09T10:00:00.000Z"),
        },
        {
          start: new Date("2024-12-09T10:00:00.000Z"),
          end: new Date("2024-12-10T10:00:00.000Z"),
        },
        {
          start: new Date("2024-12-10T10:00:00.000Z"),
          end: new Date("2024-12-11T10:00:00.000Z"),
        },
        {
          start: new Date("2024-12-11T10:00:00.000Z"),
          end: new Date("2024-12-12T10:00:00.000Z"),
        },
        {
          start: new Date("2024-12-12T10:00:00.000Z"),
          end: new Date("2024-12-13T10:00:00.000Z"),
        },
      ],
    },
  };
};
